import React, { useEffect, useRef, useState } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import Alerts from "../util/Alerts";
import axios from "axios";
import { routes } from "../gen/General";
import { findImageRed, findRed, ListRedes } from "./utils";
import { SeccionHeader, SeccionSalir } from "./ComponentPolizas";
import { SeccionAtras } from "./RedBeneficios";
import lupa from "../assets/img/lupa.png";
import buscar from "../assets/img/icon/icon_buscar.svg";
import { ResultadoFiltro } from "./ResultadoFiltro";

export const CompTipoBeneficios = props => {
    const [asegs, setAsegs] = useState([]);
    const [plan, setPlan] = useState({});
    const [red, setRed] = useState("");
    const [query, setQuery] = useState({
        esp: "",
        ciu: "",
        prov: "",
        nombre: "",
        cdPlan: props.match.params.id,
        red: props.match.params.red,
    });
    const [esps, setEsps] = useState([]);
    const [proveedores, setProveedores] = useState([]);
    const [medicos, setMedicos] = useState([]);
    const [cius, setCiudades] = useState([]);
    const [listFiltro, setListFiltro] = useState([]); // beneficios filtrados
    const [redCoberturas, setRedCoberturas] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [showResults, setShowResults] = useState(false);

    const alert = useRef(null);
    const firstRender = useRef(true);

    useEffect(() => {
        getAseguradora();
        setRed(props.match.params.red);
        getPlan(props.match.params.id);
        setQuery({ ...query, cdPlan: props.match.params.id, red: props.match.params.red });
        getEspecialidades();
        getCiudades();
        if (props.match.params.red !== "S") {
            getInfo();
        }
        fetchRedCoberturas();
    }, [props.match.params.id, props.match.params.tp, props.match.params.red]);

    useEffect(() => {
        if (!firstRender.current) {
            if (listFiltro?.length < 1) {
                alert.current.show_error("No se encontraron resultados");
            } else {
                setShowResults(true);
            }
        }
        firstRender.current = false;
    }, [listFiltro]);

    function getAseguradora() {
        axios
            .get(routes.base + "/aseguradora")
            .then(resp => {
                setAsegs(resp.data);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    }

    function getPlan(cdPlan) {
        axios
            .get(routes.base + "/plan", { params: { cdPlan } })
            .then(resp => {
                setPlan(resp.data);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    }

    function getEspecialidades() {
        setLoadingData(true);
        const cdPlan = props.match.params.id;
        const red = ListRedes.find(l => l.letra === props.match.params.red)?.id || "";
        axios
            .get(routes.base + "/beneficios/seccion-filtros", { params: { cdPlan, red } })
            .then(resp => {
                setEsps(resp.data.especialidades);
                setProveedores(resp.data.proveedores);
                setMedicos(resp.data.medicos);
            })
            .catch(error => alert.current.handle_error(error))
            .finally(() => setLoadingData(false));
    }

    function getCiudades() {
        axios
            .get(routes.base + "/ciudades")
            .then(resp => {
                setCiudades(resp.data);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    }

    function getInfo() {
        axios
            .get("https://ip.nf/me.json")
            .then(resp => {
                let info = resp.data;
                setQuery({ ...query, ciu: info?.ip?.city ? info?.ip?.city.toUpperCase() : "" });
            })
            .catch(error => {
                setQuery({ ...query, ciu: "QUITO" });
            });
    }

    function getList(values) {
        axios
            .post(routes.base + "/beneficios/search", values)
            .then(resp => {
                let lista = Object.entries(resp.data);
                setListFiltro(lista);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    }

    const fetchRedCoberturas = () => {
        axios
            .get(routes.base + "/red-coberturas")
            .then(resp => setRedCoberturas(resp.data))
            .catch(err => alert.current.handle_error(err));
    };

    return (
        <>
            <div className="content">
                <Alerts ref={alert} />
                {!showResults ? (
                    <Row>
                        <div>
                            <Card
                                className={"beneficios__card"}
                                style={{
                                    backgroundImage: `url(${lupa})`,
                                    backgroundPosition: "bottom 12% right 3%",
                                    backgroundRepeat: "no-repeat",
                                }}
                            >
                                <div>
                                    <SeccionHeader idx={3} />
                                    <div className="row justify-content-between">
                                        <SeccionAtras
                                            to={
                                                "/list/beneficios/" +
                                                props.match.params.tp +
                                                "/" +
                                                props.match.params.id
                                            }
                                        />
                                        <SeccionSalir to={"/" + props.match.params.tp + "/polizas"} />
                                    </div>
                                </div>
                                <CardHeader className={"my-2"}>
                                    <Row>
                                        <Col md={5} className={"px-md-0"}>
                                            <h4 className="titulos">{findRed(red) + ":"}</h4>
                                            <h4 className={"sub-titulos font-medium"}>{plan.dscPlan}</h4>
                                        </Col>
                                        <Col xs={4} md={1} className={"p-md-0"}>
                                            <img src={findImageRed(red)} alt="" />
                                        </Col>
                                        <Col xs={8} md={5} className={"p-md-0"}>
                                            <span className={"text-primary"}>
                                                {
                                                    "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat."
                                                }
                                            </span>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <div className="container">
                                        <Row>
                                            <Col md={12}>
                                                <Row className={"font-medium"}>
                                                    <div className="col-md-6 mt-4 mb-2 my-md-4">
                                                        <label>
                                                            {"Especialidad "}
                                                            {loadingData && (
                                                                <i className={"fa-solid fa-spinner fa-spin-pulse"} />
                                                            )}
                                                        </label>
                                                        <select
                                                            value={query.esp}
                                                            className="form-control primary"
                                                            onChange={e => {
                                                                setQuery({ ...query, esp: e.target.value });
                                                            }}
                                                        >
                                                            <option value="">--Todos--</option>
                                                            {(esps || []).map(a => (
                                                                <option key={a} value={a}>
                                                                    {a}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    {red !== "S" && (
                                                        <>
                                                            <div className="col-md-6 my-2 my-md-4">
                                                                <label>{"Ciudad"}</label>
                                                                <select
                                                                    value={query.ciu}
                                                                    className="form-control primary"
                                                                    onChange={e => {
                                                                        setQuery({ ...query, ciu: e.target.value });
                                                                    }}
                                                                >
                                                                    <option value="">--Todos--</option>
                                                                    {(cius || []).map(a => (
                                                                        <option key={a.cdCiudad} value={a.nmCiudad}>
                                                                            {a.nmCiudad}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="col-md-6 my-2 my-md-4">
                                                                <label>
                                                                    {"Prestador / Proveedor "}
                                                                    {loadingData && (
                                                                        <i
                                                                            className={
                                                                                "fa-solid fa-spinner fa-spin-pulse"
                                                                            }
                                                                        />
                                                                    )}
                                                                </label>
                                                                <select
                                                                    value={query.prov}
                                                                    className="form-control primary"
                                                                    onChange={e => {
                                                                        setQuery({ ...query, prov: e.target.value });
                                                                    }}
                                                                >
                                                                    <option value="">--Todos--</option>
                                                                    {(proveedores || []).map(a => (
                                                                        <option key={a} value={a}>
                                                                            {a}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            {red !== "F" && (
                                                                <div className="col-md-6 my-2 my-md-4">
                                                                    <label>
                                                                        {"Nombre del Médico "}
                                                                        {loadingData && (
                                                                            <i
                                                                                className={
                                                                                    "fa-solid fa-spinner fa-spin-pulse"
                                                                                }
                                                                            />
                                                                        )}
                                                                    </label>
                                                                    <select
                                                                        value={query.nombre}
                                                                        className="form-control primary"
                                                                        onChange={e => {
                                                                            setQuery({
                                                                                ...query,
                                                                                nombre: e.target.value,
                                                                            });
                                                                        }}
                                                                    >
                                                                        <option value="">--Todos--</option>
                                                                        {(medicos || []).map(a => (
                                                                            <option key={a} value={a}>
                                                                                {a}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </Row>
                                            </Col>
                                        </Row>
                                        <br />
                                        <div className="col-12 beneficios mt-3">
                                            <div className="beneficios__buscar">
                                                <button
                                                    type={"button"}
                                                    className={"btn beneficios__btn mt-4"}
                                                    onClick={() => getList(query)}
                                                >
                                                    <img src={buscar} alt="" width={"15"} />
                                                    &nbsp;
                                                    <span>Buscar</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    </Row>
                ) : (
                    <ResultadoFiltro
                        tp={props.match.params.tp}
                        red={red}
                        redCoberturas={redCoberturas}
                        listFiltro={listFiltro}
                        ciudad={query.ciu || ""}
                        setShowResults={setShowResults}
                    />
                )}
            </div>
        </>
    );
};
